import type { WorkbenchVisualizationTone } from "./WorkbenchScatterPlot";

const toneVariable: Record<WorkbenchVisualizationTone, string> = {
  primary: "--radar-series-one",
  secondary: "--radar-series-two",
  accent: "--radar-series-three",
  muted: "--radar-series-four",
};

const toneFallback: Record<WorkbenchVisualizationTone, string> = {
  primary: "var(--primary)",
  secondary: "var(--secondary-foreground)",
  accent: "var(--accent-foreground)",
  muted: "var(--muted-foreground)",
};

export const workbenchVisualizationToneColor = (tone: WorkbenchVisualizationTone) =>
  `hsl(var(${toneVariable[tone]}, ${toneFallback[tone]}))`;

export const workbenchVisualizationToneColorWithAlpha = (
  tone: WorkbenchVisualizationTone,
  alpha: number,
) => `hsl(var(${toneVariable[tone]}, ${toneFallback[tone]}) / ${alpha})`;
